export default class CDNBehavior {

  constructor() {
    this.form = document.getElementById('cdn_behavior_update');
    if (this.form) {
      window.solodev.submitForm = () => this.form.submit();
    }
  }
}
